module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex flex-column tc bg-white new-shadow-theme br3 w-100 pv4 h-100 main-container"
  }, [_c('div', {
    staticClass: "flex flex-column flex-direction h-100 ph4 justify-between content"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.phoneModelsWithCount), function(deviceInfo, index) {
    return _c('device-info', {
      key: index,
      attrs: {
        "index": index,
        "deviceInfo": deviceInfo,
        "phoneModels": _vm.phoneModels,
        "getCoveragePhoneOnly": _vm.getCoverage,
        "isMonthly": _vm.monthlyToggle,
        "isPhoneOnly": _vm.isPhoneOnly,
        "isMulti": _vm.filteredPhones.length > 1,
        "isCartInfo": true
      }
    })
  })], 2)]), _vm._v(" "), _c('discount-code', {
    staticClass: "mt3",
    attrs: {
      "isMonthly": _vm.monthlyToggle,
      "totalPrice": _vm.totalPrice,
      "price": _vm.price,
      "oneTimeVerification": _vm.oneTimeVerification,
      "discount": _vm.discount
    },
    on: {
      "update:totalPrice": function($event) {
        _vm.totalPrice = $event
      },
      "update:total-price": function($event) {
        _vm.totalPrice = $event
      },
      "update:oneTimeVerification": function($event) {
        _vm.oneTimeVerification = $event
      },
      "update:one-time-verification": function($event) {
        _vm.oneTimeVerification = $event
      },
      "update:discount": function($event) {
        _vm.discount = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "separation-line w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column"
  }, [(this.enteredDiscount.code_name || _vm.filteredPhones.length > 1) ? _c('div', {
    staticClass: "flex flex-column ph4 items-start justify-start mt3"
  }, [_c('div', {
    staticClass: "inter-medium fw6 f6 mb2"
  }, [_vm._v(" Discounts: ")]), _vm._v(" "), (_vm.filteredPhones.length > 1) ? _c('div', {
    staticClass: "inter black-50 f7 mb2"
  }, [_vm._v("\n          5% Multi-Plan Discount Applied\n        ")]) : _vm._e(), _vm._v(" "), (this.enteredDiscount.code_name) ? _c('div', {
    staticClass: "flex flex-row inter mb1 items-center"
  }, [_c('div', {
    staticClass: "inter f7"
  }, [_vm._v(" -$" + _vm._s(_vm.discount.toFixed(2)) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "inter black-50 f7 ml2"
  }, [_vm._v(" (" + _vm._s(_vm.enteredDiscount.code_name) + ") ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row ph4 justify-between mv3 f4 total-price"
  }, [_c('label', {
    staticClass: "inter-medium black-40"
  }, [_vm._v("Grand Total")]), _vm._v(" "), (_vm.oneTimeVerification) ? _c('div', {
    staticClass: "flex flex-column cera-round-pro-medium margin items-end"
  }, [_vm._v("\n          $" + _vm._s(_vm.totalPrice) + "\n          "), (_vm.oneTimeVerification) ? _c('div', {
    staticClass: "inter black-50 f7 mt1"
  }, [_vm._v(" \n            One-time verification charge \n          ")]) : _vm._e()]) : _c('div', {
    staticClass: "flex flex-column cera-round-pro-medium margin items-end"
  }, [_vm._v("\n          $" + _vm._s(_vm.totalPrice) + " / " + _vm._s(_vm.monthlyToggle ? 'month' : 'year') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "separation-line mb3 w-100"
  }), _vm._v(" "), _c('terms-and-conds', {
    attrs: {
      "isChecked": _vm.hasAgreed,
      "isStudent": _vm.isStudent,
      "onCheck": _vm.onCheck,
      "customClass": "ph4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3 center ph4 w-100"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "newDisabled": _vm.disabledButton,
      "newPrimary": "",
      "customClass": "button-custom"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Register Now\n      ")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row w-100 items-center justify-between h2 mb3"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 black tl"
  }, [_vm._v("\n            Checkout\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1593553e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/cartTotalInfo/CartTotalInfo.vue
// module id = 983
// module chunks = 0